import { ACTIONS } from './actions';

const defaultState = {
    isOpen: false,
    intl: {
        close: "",
        title: ""
    },
    courseTitle: null,
    launchParams: null,
    orgId: null,
    studentId: null
}

export default function Reducer(state = defaultState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case ACTIONS.OPEN_COMPLETION_MODAL:
            return {
                ...state,
                isOpen: true,
                courseTitle: payload.courseTitle,
                launchParams: payload.launchParams,
                orgId: payload.orgId,
                studentId: payload.studentId,
            }
        case ACTIONS.CLOSE_COMPLETION_MODAL:
            return {
                ...state,
                isOpen: false
            }
        default:
            return state
    }
}